var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoAllianz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg39820",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 592 207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-3 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-1, .cls-3 {\r\n        fill: #143861;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-4 {\r\n        clip-path: url(#clippath);\r\n      }\r\n\r\n      .cls-3 {\r\n        fillRule: evenodd;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 26.9,
    width: 592,
    height: 153.2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g39870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path37627",
    className: "cls-3",
    d: "M53.6,109.5h-21.7l11.5-37.5,10.2,37.5ZM21.7,147.4l6.8-22.9h27.8l6.8,22.9h23.1l-24.4-86.7c-1.4-5.7-4.1-7.5-10.2-7.5H17.6v7.8h2.7c4.1,0,6.1,1.3,6.1,4.4s0,3.3-2,7.9L0,147.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37629",
    className: "cls-1",
    d: "M115.3,147.4V60.1c0-4.5-2.7-6.9-7.5-6.9h-21v7.8h1.4c4.1,0,6.1,1.7,6.1,5.4v81.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37631",
    className: "cls-1",
    d: "M153.2,147.4V60.1c0-4.5-2.7-6.9-7.5-6.9h-21v7.8h1.4c4.1,0,6.1,1.7,6.1,5.4v81.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37633",
    className: "cls-3",
    d: "M191.9,61.5c0-6.2-4.7-9.9-12.2-9.9s-12.2,3.7-12.2,9.9,4.1,10.1,12.2,10.1,12.2-3.7,12.2-10.1M191.2,147.4v-63.6c0-4.4-2.7-7-6.8-7h-21v7.7h1.4c4.1,0,5.4,1.7,5.4,5.6v57.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37635",
    className: "cls-3",
    d: "M241.4,113.2v14.1c-4.1,4.1-8.8,6.4-12.9,6.4s-6.1-2-6.1-7.3,1.4-8.1,6.1-9.9c3.4-1.4,6.8-2.3,12.9-3.3M211.6,96.3l2-.8c5.4-2.2,8.8-3,12.9-3.7,2-.3,4.7-.5,6.1-.5,6.8,0,8.8,2.2,8.8,8.5v1.8c-9.5,1.6-12.2,2.1-17.6,3.3-2.7.7-5.4,1.6-8.1,2.7-8.8,3.5-12.9,10.3-12.9,21s5.4,19.7,17.6,19.7,9.5-1.1,12.9-3.3c3.4-1.6,4.7-2.4,8.8-6.1v2.2c0,4.4,2,6.5,6.1,6.5h20.3v-7.3h-.7c-4.1,0-6.1-1.8-6.1-5.5v-34.7c0-18-6.1-24.1-23.7-24.1s-11.5.7-17,2c-5.4,1.3-8.1,2.2-14.2,5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37637",
    className: "cls-3",
    d: "M300.4,147.4v-47.9c4.7-4.4,8.1-6.1,12.9-6.1s6.1,2,6.1,9.2v44.8h21v-48.1c0-9.9-1.4-14.2-4.1-17.9-3.4-3.7-7.5-5.4-13.6-5.4s-14.2,3-23.7,11.2v-3.8c0-4.4-2-6.6-6.1-6.6h-20.3v7.7h.7c4.1,0,6.1,1.7,6.1,5.6v57.4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g37643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path37645",
    className: "cls-1",
    d: "M405.5,133.9h-31.2l29.8-42.6v-14.5h-44.8c-5.4,0-7.5,2.2-7.5,7.4v12.8h7.5v-1.4c0-3.9,2-5.4,6.1-5.4h16.3l-30.5,42.6v14.6h54.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37647",
    className: "cls-3",
    d: "M525.5,143.6V63.7c0-6.4-2.7-8.5-8.8-8.5h-18.3v8.8h2c3.4,0,4.7,1.3,4.7,5.2v74.4h20.3ZM536.4,143.6h19.7v-60.3c0-6.1-2.7-8.5-8.8-8.5h-10.9v68.8ZM494.3,143.6v-68.8h-10.8c-6.1,0-8.8,2.4-8.8,8.5v60.3h19.7ZM579.1,103.4c0,37.4-27.1,64.6-63.7,64.6s-63.7-27.3-63.7-64.6,27.1-64.6,63.7-64.6,63.7,27.3,63.7,64.6M592,103.4c0-43.7-32.5-76.6-76.6-76.6s-76.6,32.8-76.6,76.6,33.2,76.7,76.6,76.7,76.6-32.8,76.6-76.7"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAllianz);
export default __webpack_public_path__ + "static/media/logo_allianz.138082850e0809e8f0fa6d4ecce78507.svg";
export { ForwardRef as ReactComponent };